import type { IGuestbookMessageRequest, IGuestMessage } from "@/types"
import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

interface UseAddGuestMessageArgs {
  message: IGuestMessage
  eventVaultId: number
}

export async function addGuestMessage(message: IGuestMessage, eventVaultId?: number) {
  const messageRequest: IGuestbookMessageRequest = {
    fromName: message.fromName,
    fromEmail: message.fromEmail,
    message: message.message,
    EventAlbumID: message.eventAlbumID,
  }

  const response = await axios.post(`api/${eventVaultId}/messages`, messageRequest)

  return response.data?.Message
}

export function useAddGuestMessage() {
  return useMutation({
    mutationFn: ({ message, eventVaultId }: UseAddGuestMessageArgs) => addGuestMessage(message, eventVaultId),
  })
}
